import _ from 'lodash';

/**
 *
 * @param {{id: number}[]} steps
 * @param {number | string[]} stepsOrder
 * @returns {any[]}
 */
export const sortSteps = (steps, stepsOrder) => _.sortBy(steps || [], (item) => stepsOrder.map(Number).indexOf(item.id));
